<div class="panel-body ">
    <ng-container *ngFor="let party of juvenileCase.getPartyList(); let pt = index">
       <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
         <div class="panel-title" id="{{'juvenile-caseDetails-parties-' + pt + '-partyNumber'}}">
            <span [id]="'P-' + party.getPartyKey()">
              <span class="field-code"> json='partyList.name'</span>{{party.getJuvenileName()}} 
              <span class="field-code">json='partyList.partyType'</span>({{party.getPartyType()}})
              <span *ngIf="party.getPartyNotes()!==''" [popover]="popTemplate" triggers="click" outsideClick="true"><i class="glyphicon glyphicon-comment"></i></span>       
              <ng-template #popTemplate><pre [innerHtml]="party.getPartyNotes()"></pre></ng-template>
              <!-- <span *ngIf="party.getPartyNotes()!==''" popover='{{party.getPartyNotes()}}' ><i class="glyphicon glyphicon-comment"></i></span>            -->
            </span>
         </div>
         <div class="panel-body">
          <div class="row">
            <div class="col-md-12 panel panel-default" *ngIf="party.getPartyAliasList().length !== 0 ">
              <div class="panel-title" id="{{'V096a-'+pt}}"><span class="field-code"> json='partyAliasList.aliasName'</span>Alias Names</div>
              <div class="panel-body" *ngIf="party.getPartyAliasList().length > 0">
                 <ol class="four-column">
                  <li *ngFor="let alias of party.getPartyAliasList(); let al = index" id="{{'juvenile-caseDetails-parties-' + pt + '-alias-' + al + '-name'}}">
                       {{alias.aliasName}}
                  </li>
                </ol>
              </div>
            </div>
          </div>
  
            <!-- <div class="panel-body"> -->
                <div class="row row-eq-height">
                    <div class="col-md-6 panel panel-default">
                        <div class="panel panel-default" *ngIf="party.isAddressPresent() === true">
                            <div id="{{'X112-'+pt}}" class="panel-title">
                              Addresses
                            </div>                            
                            <!-- <div *ngIf="party.getPartyAddressIsBlank(address) === false" class="panel-body"> -->
                                <div class="table-responsive">
                                  <span class="field-code">V111 Show table or not. json='privacyIndicatorCode.code#'</span>
                                  <table id="partyAddress-table" class="table table-condensed table-striped">
                                    <tbody>
                                      <div *ngIf="party.isPrimaryAddressExist() === true">
                                        <tr *ngIf="party.getPrimaryAddress()!==''">
                                          <td>
                                            <span class="field-code">V112a json='address.line1' </span>
                                            <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine1'}}">   
                                              {{party.getPrimaryAddress()}}
                                            </span>
                                          </td>
                                        </tr>
                
                                        <tr>
                                          <td> 
                                            <div *ngIf=" party.getPrimaryCity()!=='' ||  party.getPrimaryState()!=='' || party.getPrimaryZipCode()!=='' ">
                                            <span id="V113a" class="field-code">V113a json='address.line2'</span>
                                            <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine2'}}">
                                                <span *ngIf=" party.getPrimaryCity()!==''">  {{party.getPrimaryCity() }} </span>                                                
                                                <span *ngIf="party.getPrimaryState()!==''"> {{ ', ' + party.getPrimaryState()}} </span>
                                                <span *ngIf="party.getPrimaryZipCode()!==''"> {{ ' ' + party.getPrimaryZipCode()}} </span>
                                            </span>
                                            </div>
                                          </td>
                                        </tr> 
                
                                        <tr *ngIf="party.getPrimaryCountry()!==''">
                                          <td>
                                            <span id="V115a" class="field-code">V115a, V116a, V117a json='address.cityName'</span>
                                            <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesCityStateZipCodeName'}}">
                                              {{party.getPrimaryCountry()}}
                                            </span>
                                          </td>
                                        </tr>                                       
                                                               
                                      </div>

                                      <div *ngIf="party.isPrimaryAddressExist() === true && party.isSecondaryAddressExist() === true">
                                          <tr>
                                              <td>
                                                <span class="field-code">V112a json='address.line1' </span>
                                                <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine1'}}"> 
                                                 or
                                                </span>
                                              </td>
                                            </tr>
                                            </div>
                                            <div *ngIf="party.isSecondaryAddressExist() === true">
                                        <tr *ngIf="party.getSecondaryAddress() !== ''">
                                          <td>
                                            <span class="field-code">V112a json='address.line1' </span>
                                            <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine1'}}">   
                                              {{party.getSecondaryAddress()}}
                                            </span>
                                          </td>
                                        </tr>
                
                                        <tr>
                                          <td>
                                            <div *ngIf=" party.getSecondaryCity()!=='' ||  party.getSecondaryState()!=='' || party.getSecondaryZipCode()!=='' ">
                                            <span id="V113a" class="field-code">V113a json='address.line2'</span>
                                            <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine2'}}"> 
                                                <span *ngIf="party.getSecondaryCity()!==''">{{party.getSecondaryCity()}}</span>                                                
                                                <span *ngIf="party.getSecondaryState()!==''">{{', ' + party.getSecondaryState()}}</span>
                                                <span *ngIf="party.getSecondaryZipCode()!== ''">{{' ' + party.getSecondaryZipCode()}}</span>                                              
                                            </span>
                                            </div>
                                          </td>
                                        </tr> 
                
                                        <tr *ngIf="party.getSecondaryCountry()!==''">
                                          <td>
                                            <span id="V115a" class="field-code">V115a, V116a, V117a json='address.cityName'</span>
                                            <span id="{{'juvenile-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesCityStateZipCodeName'}}">
                                              {{party.getSecondaryCountry()}}
                                            </span>
                                          </td>
                                        </tr>                                       
                                                              
                                      </div>
                                      
                                    </tbody>
                                  </table>
                                </div>
                              <!-- </div> -->
                        </div>
                        <div class="panel panel-default" *ngIf="party.getPrimaryPhone(address) !== '' 
                        || party.getSecondaryPhone(address) !== '' || party.getFaxNumber(address) !== ''">
                            <div class="panel-title">
                                Phone Numbers
                            </div>
                            <div class="panel-body">
                                <span class="field-code">json='privacyIndicatorCode.code#'</span>
                                <dl class="dl-vertical">
                                   <div *ngIf="party.getPrimaryPhone(address) !== ''">
                                      <dt id="{{'V119-'+pt}}" class="summary-label">
                                        <span class="field-code">json='address.primaryPhone'</span>Phone
                                      </dt>
                                      <dd id="{{'juvenile-caseDetails-parties-' + pt + '-partyPhoneNumber'}}">
                                        {{party.getPrimaryPhone(address)}}
                                      </dd>
                                   </div>
                                   <div *ngIf="party.getSecondaryPhone(address) !== ''">
                                    <dd id="{{'juvenile-caseDetails-parties-' + pt + '-partyPhoneNumber'}}">
                                      {{party.getSecondaryPhone(address)}}
                                    </dd>
                                 </div>
                                  <div *ngIf="party.getFaxNumber(address) !== ''">
                                  <dt  id="{{'V120-'+pt}}" class="summary-label">
                                    <span class="field-code">json='address.faxNumber'</span>Fax
                                  </dt>
                                  <dd id="{{'juvenile-caseDetails-parties-' + pt + '-partyFaxNumber'}}">
                                    {{party.getFaxNumber(address)}}
                                  </dd>
                                  </div>
                                </dl>
                              </div>
                        </div>
                    </div>
                    <div class="col-sm-6 panel panel-default">
                        <div class="panel panel-default" *ngIf="party.getDateOfBirth() !== ''">
                            <div id="V076" class="panel-title ">
                                <span class="field-code "></span>Date of Birth
                              </div>
                              <div class="panel-body" >{{party.getDateOfBirth() | date:'MM/dd/yyyy'}}</div>
                        </div>
                        <div class="panel panel-default" *ngIf="party.getRace() !== ''">
                            <div id="V076" class="panel-title ">
                                <span class="field-code "></span>Race
                              </div>
                              <div class="panel-body ">{{party.getRace()}}</div>
                        </div>
                        <div class="panel panel-default" *ngIf="party.getGender() !== ''">
                            <div id="V076" class="panel-title ">
                                <span class="field-code "></span>Sex
                              </div>
                              <div class="panel-body ">{{party.getGender()}}</div>
                        </div>
                        <div class="panel panel-default" *ngIf="party.getCaseStatus() !== ''">
                            <div id="V076" class="panel-title ">
                                <span class="field-code "></span>Case Status
                              </div>
                              <div class="panel-body ">{{party.getCaseStatus()}}</div>
                        </div>
                    </div>
                </div>
            <!-- </div> -->

            <div class="row " *ngIf="party.getPartyAttorneyList().length !== 0">
              <div class="col-md-12 panel panel-default ">
                <div id="{{'X122a-'+pt}}" class="panel-title ">
                  Attorneys
                </div>
                <div class="panel-body ">
                  <table id="{{'partyAttorney-table-' + pt}}" class="table table-condensed table-striped ">
                    <thead>
                      <tr>
                        <th id="{{'V122a-'+pt}}"><span class="field-code ">json='attorney.attorneyName','primaryIndicator#'</span>Name</th>
                        <th id="{{'V121a-'+pt}}"><span class="field-code ">json='primaryIndicator#','attorney.barNumber#'</span> North Carolina State Bar Number</th>
                        <th id="{{'V120a-'+pt}}"><span class="field-code ">json='attorney.assignment','primaryIndicator#'</span>Assignment</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tr *ngFor="let attorney of party.getPartyAttorneyList(); let at = index"> -->
                          <tr *ngFor="let attorney of  getAttorneyList(pt); let at = index">
                        <td id="{{'juvenile-caseDetails-parties-' + pt + '-attorney-' + at + '-attorneyName'}}">
                          {{attorney.getAttorneyName()}}
                          <span *ngIf="attorney.getAttorneyNotes()!==''" [popover]="attorneyTemplate" triggers="click" outsideClick="true"><i class="glyphicon glyphicon-comment"></i></span>       
                          <ng-template #attorneyTemplate><pre [innerHtml]="attorney.getAttorneyNotes()"></pre></ng-template>
                          <!-- <span *ngIf="attorney.getAttorneyNotes()!==''" popover='{{attorney.getAttorneyNotes()}}' ><i class="glyphicon glyphicon-comment"></i></span> -->
                        </td>
                        <td id="{{'juvenile-caseDetails-parties-' + pt + '-attorney-' + at + '-attorneyBarNumber'}}">
                          {{attorney.getBarNumber()}}
                        </td>
                        <td id="{{'juvenile-caseDetails-parties-' + pt + '-attorney-' + at + '-attorneyAssignment'}}">
                          {{attorney.getAssignment()}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
       </div>
    </ng-container>
  </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/parties-details/parties-details.component.html